// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-group-button {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    width: 40%;
}
.ant-select-arrow{
    height: 31.4px;
    top: 6px;
    right: -1px;
}`, "",{"version":3,"sources":["webpack://./src/modules/Reports/Tat-Report/tat.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB,UAAU;AACd;AACA;IACI,cAAc;IACd,QAAQ;IACR,WAAW;AACf","sourcesContent":[".input-group-button {\r\n    position: relative;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: stretch;\r\n    width: 40%;\r\n}\r\n.ant-select-arrow{\r\n    height: 31.4px;\r\n    top: 6px;\r\n    right: -1px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
